import { useAuth } from '@features/auth/hooks/useAuth';
import { hasPermission } from './permissionMap';
import type { Permission } from './permissions.const';

/**
 * İzin kontrolü artık backend'in token'a bastığı `permissions` claim'lerine
 * dayanır (FE'deki sabit rol→izin matrisi kaldırıldı). Her FE anahtarı
 * `FE_TO_BE` ile gerçek BE policy'sine çözülür; SuperAdmin tümünü geçer.
 * Böylece RolesPage'deki izin düzenlemeleri (sonraki giriş/yenileme ile) FE'ye
 * de yansır.
 */
export function useCan(permission: Permission): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return hasPermission(permission, user.permissions, user.roles);
}

export function useCanAny(permissions: readonly Permission[]): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return permissions.some((p) => hasPermission(p, user.permissions, user.roles));
}

export function useCanAll(permissions: readonly Permission[]): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return permissions.every((p) => hasPermission(p, user.permissions, user.roles));
}
